import { Component, Inject, Input } from '@angular/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import {
  FacebookFormConfiguration,
  FacebookLeadAdsFormAutomationConfigurationService,
} from '../../fb-forms-automation-configuration.service';

@Component({
  templateUrl: 'connected-cell.component.html',
  styleUrls: [],
  standalone: false,
})
export class ConnectedCellComponent implements CustomCellComponent<FacebookFormConfiguration> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() element: FacebookFormConfiguration;

  constructor(
    @Inject('SAVE_ON_CHANGES') private readonly saveOnChanges: boolean,
    private readonly dataService: FacebookLeadAdsFormAutomationConfigurationService,
  ) {}

  updateConnectedStatus(enabled: boolean): void {
    this.dataService.updateFormConnectedStatus(this.element.formID, enabled, this.saveOnChanges);
  }
}
